import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Badge } from '../ui/badge';
import { StatusBreakdownItem } from '../../types';
import { formatNumber } from '../../constants/nginx-sites';

interface HttpStatusTableProps {
  data: StatusBreakdownItem[] | null;
}

export function HttpStatusTable({ data }: HttpStatusTableProps) {
  if (!data || data.length === 0) {
    return null;
  }

  const getStatusVariant = (status: number) => {
    if (status >= 200 && status < 300) return 'default'; // green
    if (status >= 300 && status < 400) return 'secondary'; // blue
    if (status >= 400 && status < 500) return 'outline'; // yellow
    if (status >= 500) return 'destructive'; // red
    return 'secondary';
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Status HTTP</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Contagem</TableHead>
              <TableHead className="text-right">Porcentagem</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item) => (
              <TableRow key={item.status}>
                <TableCell>
                  <Badge variant={getStatusVariant(item.status)}>{item.status}</Badge>
                </TableCell>
                <TableCell className="text-right">{formatNumber(item.count)}</TableCell>
                <TableCell className="text-right">{(item.percentage ?? 0).toFixed(1)}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
